import React from "react";
import { ToolRendererProps } from "./types";
import { TodoListBlock } from "../TodoListBlock";

export const TaskToolRenderer: React.FC<ToolRendererProps> = ({
  args,
  renderWithErrorIfFailed,
}) => {
  const subagentType = args?.subagent_type || "";
  const description = args?.description || "";

  return (
    <>
      {renderWithErrorIfFailed(
        <div className="text-xs text-secondary-n-400 space-y-2">
          {subagentType && (
            <div>
              Agent:{" "}
              <span className="font-medium capitalize">
                {subagentType.replace("-", " ")}
              </span>
            </div>
          )}
          {description && (
            <div>
              Task: <span className="font-medium">{description}</span>
            </div>
          )}
        </div>,
      )}
    </>
  );
};

export const TodoWriteToolRenderer: React.FC<ToolRendererProps> = ({
  args,
  status,
  renderWithErrorIfFailed,
  getFallbackText,
}) => {
  const todos = args?.todos || [];

  return todos.length > 0
    ? renderWithErrorIfFailed(<TodoListBlock todos={todos} status={status} />)
    : getFallbackText();
};
